import React from "react";
import StaffNavBar from "../components/StaffNavBar";
import { useStaffNews } from "../store/staff";
import AdminNewsDetail from "../adminPages/NewsDetail";

export default function StaffNewsDetail() {
  return (
    <AdminNewsDetail
      useNewsStore={useStaffNews}
      NavbarComponent={StaffNavBar}
      backPath="/staff/news-management"
    />
  );
}
